// External dependencies
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import Button from "../components/Button/Button.edit";
import { RichText, InspectorControls } from "@wordpress/block-editor";
import { PanelBody, SelectControl, CheckboxControl } from "@wordpress/components";

// Block attributes (custom props)
const attributes = {
    cta: {
        type: "object",
        default: null,
    },
    type: {
        type: "string",
        default: "button",
    },
}

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, attributes }) => {
    const { cta, type } = attributes;
    console.log('button edit', cta)

    return (
        <Fragment>
            <InspectorControls>
                <PanelBody title={__("")}>
                    <SelectControl
                        label="Button type"
                        options={[
                            { value: "link", label: "Link" },
                            { value: "button", label: "Button" },
                            { value: "none", label: "None" },
                        ]}
                        value={type}
                        onChange={(type) => setAttributes({ cta: null, type })}
                    />
                </PanelBody>
            </InspectorControls>
            <div className="gutenberg-button-new-experience" style={{ position: 'relative' }}>
                {type === "button"
                    ? (<Button
                        value={cta}
                        onChange={(cta) => setAttributes({ cta })}
                    />)
                    : type === "link"
                        ? (<RichText
                            value={cta?.text}
                            multiline={false}
                            inlineToolbar={false}
                            onChange={(text) => setAttributes({ cta: { text } })}
                            placeholder={__("Hero CTA", "hero")}
                            allowedFormats={["core/link"]}
                            keepPlaceholderOnFocus={true}
                        />)
                        : null}
            </div>
        </Fragment>
    );
}

// Edit function (responsible for wp-admin post edit screen)
const save = ({ attributes }) => {
    const { cta, type } = attributes;

    return (
        <div className="gutenberg-button-new-experience" style={{ position: 'relative' }}>
            {type === "button"
                ? (<Button.Content value={cta} />)
                : type === "link"
                    ? (<RichText.Content
                        value={cta?.text}
                    />)
                    : null}
        </div>
    )
}

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-button-new-experience", {

    /**
     * This is the display title for your block, which can be translated with `i18n` functions.
     * The block inserter will show this name.
     */
    title: __("Button (new experience)", "gutenberg-button-new-experience"),

    /**
     * An icon property should be specified to make it easier to identify a block.
     * These can be any of WordPress’ Dashicons, or a custom svg element.
     */
    icon: "align-wide",

    /**
     * Blocks are grouped into categories to help users browse and discover them.
     * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
     */
    category: "widgets",

    /**
     * Optional block extended support features.
     */
    // supports: {
    //     // Removes support for an HTML mode.
    //     html: false
    // },
    attributes,

    /**
     * The edit function describes the structure of your block in the context of the editor.
     * This represents what the editor will render when the block is used.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
     *
     * @param {Object} [props] Properties passed from the editor.
     *
     * @return {WPElement} Element to render.
     */
    edit,

    /**
     * The save function defines the way in which the different attributes should be combined
     * into the final markup, which is then serialized by the block editor into `post_content`.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
     *
     * @return {WPElement} Element to render.
     */
    save
});
